import type { IMasterDataDeductionCategoryRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataDeductionCategoryDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataDeductionCategoryUseCase {
  private readonly repository: IMasterDataDeductionCategoryRepository;

  constructor(repository: IMasterDataDeductionCategoryRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataDeductionCategoryDTO) {
    return this.repository.createDeductionCategory(params);
  }
}
